module.exports = __webpack_public_path__ + "img/Sudan.857d0108.svg";